import React, { useEffect } from "react";
import { useNavigate, Navigate, useSearchParams } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "../hooks/redux-hooks";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { Button, Box, Alert } from "@mui/material";
import { styles } from "../styles/selectionStyles";
import { customerStatus, WEB_URL } from "../constants";
import { logout } from "../slices/authSlice";
import blueskyImage from '../assets/bluesky.png';

const SelectionPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  // 从wordpress跳转
  const [searchParams] = useSearchParams();
  // console.log("searchParams", searchParams);
  const isFromWordPress = searchParams.get('source') === 'wordpress';
  const lang = isFromWordPress ? searchParams.get('lang') || 'en' : localStorage.getItem('userLanguage') || 'en';
  useEffect(() => {
    // console.log("lang0", lang);
    // 保存语言选择到 localStorage
    if (isFromWordPress) {
      localStorage.setItem('userLanguage', lang);
      i18n.changeLanguage(lang);
    }
  }, [lang]);

  const basicUserInfo = useAppSelector((state) => state.auth.basicUserInfo);

  // const handleLogout = () => {
  //   dispatch(logout());
  //   navigate("/login");
  // };

  if (!basicUserInfo) {
    return <Navigate replace to={"/login"} />;
  }

  return (
    <div style={styles.container}>
      <div style={styles.buttonContainer}>
      <Box
                component="img"
                src={blueskyImage}
                alt="Blue Sky Logo"
                sx={{
                  display: "block",
                  margin: "0 auto",
                  width: { xs: "150px", sm: "200px" },
                  height: "auto",
                  mb: 2,
                }}
              />
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 0, mb: 0 }}
          onClick={() => navigate("/pickup")}
        >
          {t("selectPickup")}
        </Button>
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 0, mb: 0 }}
          onClick={() => navigate("/dropoff")}
        >
          {t("selectDropoff")}
        </Button>
        {/* <Button
              fullWidth
              variant="contained"
              sx={{ mt: 0, mb: 0 }}
              onClick={() => navigate("/aroundcity")}
            >
              {t("selectAroundCity")}
        </Button> */}
        {basicUserInfo && basicUserInfo.is_guest === true && (
          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 0, mb: 0 }}
            onClick={() => navigate("/order-search")}
          >
            {t("btnQueryOrder")}
          </Button>
        )}
        {basicUserInfo && basicUserInfo.is_guest === false && (
          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 0, mb: 0 }}
            onClick={() => navigate("/orderdoor")}
          >
            {t("btnCurOrder")}
          </Button>
        )}
        {basicUserInfo && basicUserInfo.is_guest === false && (
          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 0, mb: 0 }}
            onClick={() => navigate("/history")}
          >
            {t("btnHistory")}
          </Button>
        )}
        {basicUserInfo && basicUserInfo.is_guest === false && (
          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 0, mb: 0 }}
            onClick={() => navigate("/myinfo")}
          >
            {t("selectMyInfo")}
          </Button>
        )}
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 0, mb: 0 }}
          onClick={() => window.location.href = WEB_URL}
        >
          {t("btnBackToWeb")}
        </Button>
        {/* <Button
          fullWidth
          variant="contained"
          sx={{ mt: 0, mb: 0 }}
          onClick={handleLogout}
        >
          {t("btnLogout")}
        </Button> */}
      </div>
      {basicUserInfo?.status != customerStatus.NORMAL && (
        <Alert
          severity={
            basicUserInfo?.status === customerStatus.BAN ? "error" : "warning"
          }
          sx={{
            mb: 2,
            mt: 4,
            width: "100%",
            maxWidth: "500px",
            margin: "32px auto 16px auto",
          }}
        >
          {basicUserInfo?.status === customerStatus.BAN
            ? t("msgUnpaidFeeBan")
            : t("msgUnpaidFeeWarning")}
        </Alert>
      )}
      <Box
        sx={{
          mt: 4,
          maxWidth: 600,
          width: "100%",
          px: 2,
          fontSize: 14,
          lineHeight: 1.6,
          textAlign: "left",
        }}
      >
        <Box sx={{ fontWeight: 600, mb: 0.5 }}>
          {t("pickupServiceExplanationTitle")}
        </Box>
        <Box sx={{ mb: 2 }}>
          {t("pickupServiceExplanationBody")}
        </Box>
        <Box sx={{ fontWeight: 600, mb: 0.5 }}>
          {t("dropoffServiceExplanationTitle")}
        </Box>
        <Box>
          {t("dropoffServiceExplanationBody")}
        </Box>
      </Box>
    </div>
  );
};

export default SelectionPage;
